<template>
  <div>
    <div class="text-center">
      <h1>このURLは利用出来ません </h1>
    </div>
    <div class="announce-container">
      <h3 class="text-red">メール本文に記載されたURLと異なるURLを指定している <br>
      （メールソフトによりURLが改行されている等）か、<br>
        URLの有効期限が切れている可能性があります。
      </h3>
      <br>
      <span>
        有効期限切れの場合は以下より<br>
        再度登録を行ってください。
      </span>
      <br>
      <br>
      <p><router-link :to="{ path: 'setting/login-info' }">{{domain}}</router-link></p>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      domain: process.env.NODE_DOMAIN + '/setting/login-info'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/ChangeEmailFail.vue